import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { fetchVehicleList } from '../api/vehicle.service'
import type { Vehicle, VehicleListFilters } from '../api/vehicle.data'
import type { PaginationModel, SortModel } from '@/components'

export function useVehicleList(
  filters?: VehicleListFilters,
  sortModel?: SortModel<Vehicle>,
  paginationModel?: PaginationModel
) {
  return useQuery({
    queryKey: ['vehicles', filters, sortModel, paginationModel],
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => fetchVehicleList(filters, sortModel, paginationModel, signal)
  })
}

export function useAllVehiclesForCompany(
  filters?: VehicleListFilters,
  refresh_timing_seconds?: number,
  pageSize: number = 20
) {
  return useInfiniteQuery({
    queryKey: ['vehicles', filters, pageSize],
    queryFn: ({ pageParam, signal }) =>
      fetchVehicleList(filters, undefined, { page: pageParam, pageSize }, signal),
    getNextPageParam: (lastPage, allPages) => {
      if (allPages.length * pageSize >= lastPage.totalItems) {
        return undefined
      }

      return allPages.length
    },
    initialPageParam: 0,
    placeholderData: keepPreviousData,
    refetchInterval:
      refresh_timing_seconds != null ? refresh_timing_seconds * 1000 : undefined,
    refetchIntervalInBackground: refresh_timing_seconds != null
  })
}
